import { render, staticRenderFns } from "./CopyLink.vue?vue&type=template&id=c58fff96"
import script from "./CopyLink.vue?vue&type=script&lang=js"
export * from "./CopyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports